import { getEnv } from '@xbcb/ui-utils';
import { UiStage } from '@xbcb/ui-types';
import { RecordType } from '@xbcb/shared-types';

// helper lib for restricted launches.

const { stage } = getEnv();

export enum FEATURE_RELEASE_KEY {
  TASK_ESCALATION = 'TASK_ESCALATION',
  PERSONNEL_DASHBOARD = 'PERSONNEL_DASHBOARD',
  TEAM_FAST_FOLLOWS = 'TEAM_FAST_FOLLOWS',
  TRANSPORTATION_TAB_SAVE = 'TRANSPORTATION_TAB_SAVE',
}

const featureReleaseConfiguration: {
  [key: string]: { restrictedStages: string[]; pendingUat: boolean };
} = {
  [RecordType.TABLE_FILTER]: {
    restrictedStages: [],
    pendingUat: false,
  },
  [RecordType.ASSIGNMENT_TEAM]: {
    restrictedStages: [],
    pendingUat: false,
  },
  [FEATURE_RELEASE_KEY.TASK_ESCALATION]: {
    restrictedStages: [],
    pendingUat: false,
  },
  [FEATURE_RELEASE_KEY.PERSONNEL_DASHBOARD]: {
    restrictedStages: [UiStage.PROD],
    pendingUat: true,
  },
  [FEATURE_RELEASE_KEY.TEAM_FAST_FOLLOWS]: {
    restrictedStages: [],
    pendingUat: false,
  },
  [FEATURE_RELEASE_KEY.TRANSPORTATION_TAB_SAVE]: {
    restrictedStages: [UiStage.PROD],
    pendingUat: true,
  },
  [RecordType.CUSTOMS_DECLARATION]: {
    restrictedStages: [],
    pendingUat: false,
  },
  [RecordType.IMPORTER_ENTITY_ACTIVATION]: {
    restrictedStages: [],
    pendingUat: false,
  },
  [RecordType.IMPORTER]: {
    restrictedStages: [],
    pendingUat: false,
  },
};
export const restrictedDeployment = (feature: string): boolean => {
  const configuration = featureReleaseConfiguration[feature];
  return (
    configuration.restrictedStages.includes(stage) && configuration.pendingUat
  );
};
